/**
 * TextRenderer — eyebrow | heading | footer
 * Pure text elements; no card wrapper needed.
 */
import React from "react";
import { Eyebrow } from "../../ui/Eyebrow";
import { Title } from "../../ui/Title";
import { Text } from "../../ui/Text";
import { EditableText } from "../EditableText";
import { AnimatedField } from "../../animations/AnimatedField";
import { resolveText } from "../../utils/resolveText";

/* eslint-disable react/prop-types */

export function TextRenderer({ element, editing, onChange, playing, isPaused, currentTimeSec }) {
  const text = resolveText(element.text);
  // Prefer field-level animation; fall back to element-level
  const boxAnimation = element.text?.boxAnimation ?? element.boxAnimation ?? null;
  const boxExitAnimation = element.text?.boxExitAnimation ?? element.boxExitAnimation ?? null;

  const editable = (
    <EditableText value={text} editing={editing} onChange={(v) => onChange?.("text", v)} />
  );

  let output;
  switch (element.type) {
    case "eyebrow":
      output = <Eyebrow>{editable}</Eyebrow>;
      break;
    case "heading":
      output = <Title size="3xl">{editable}</Title>;
      break;
    case "footer":
      output = <Text role="caption">{editable}</Text>;
      break;
    default:
      output = <Text>{editable}</Text>;
  }

  // eyebrow and footer can be very short — wrap in a min-height container so
  // the box is tall enough to grab and drag on the canvas.
  const needsMinHeight = element.type === "eyebrow" || element.type === "footer";

  return (
    <AnimatedField
      boxAnimation={boxAnimation}
      boxExitAnimation={boxExitAnimation}
      playing={playing}
      isPaused={isPaused}
      currentTimeSec={currentTimeSec}
    >
      {needsMinHeight ? (
        <div style={{ minHeight: "40px", display: "flex", alignItems: "center" }}>{output}</div>
      ) : (
        output
      )}
    </AnimatedField>
  );
}

export default TextRenderer;
